module.exports = __webpack_public_path__ + "img/auth.f29fd1a8.jpg";